import { Action } from '@ngrx/store';
import { EvaluationInterface } from 'app/assessment/evaluation/models';

import { EvaluationActionType } from './evaluation-action-type.enum';

// evaluations
export class LoadEvaluations implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.LoadEvaluations;

  constructor(public readonly payload: number) { }
}

export class LoadEvaluationsCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.LoadEvaluationsCompleted;

  constructor(public readonly payload: EvaluationInterface[]) { }
}

export class LoadEvaluationsFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.LoadEvaluationsFailed;

  constructor(public readonly payload: string) { }
}

// current evaluation
export class LoadCurrentEvaluation implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.LoadCurrentEvaluation;

  constructor(public readonly payload: {userId: number, evaluationId?: number}) { }
}

export class LoadCurrentEvaluationCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.LoadCurrentEvaluationCompleted;

  constructor(public readonly payload: EvaluationInterface) { }
}

export class LoadCurrentEvaluationFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.LoadCurrentEvaluationFailed;

  constructor(public readonly payload: string) { }
}
